import React, { Component } from "react";
import LoaderSprite from '../assets/LoaderSprite.svg';
import "./Loading.css";
import Title from "../components/Title";

class Loading extends Component {
  render() {
    const {title} = this.props;
    return (
      <React.Fragment>
        <Title text={title} />
        <img src={LoaderSprite} className='hc-l'/>
      </React.Fragment>
    );
  }
}

export default Loading;
